import {
  Conversation,
  ConversationList,
  MainContainer,
  Search,
  Sidebar,
} from "@chatscope/chat-ui-kit-react";
import Fuse from "fuse.js";
import { useEffect, useState } from "react";
import { api } from "../../api";
import { Divider } from "../../externalComponents/tailwind/divider";
import { getMessageDateFormatted } from "../../functions/getMessageDateFormatted";
import { ConversationChat } from "./shared/ConversationChat";
// eslint-disable-next-line no-unused-vars
import styles from "@chatscope/chat-ui-kit-styles/dist/default/styles.min.css";
import { useIsMobile } from "../../externalComponents/useIsMobile";

export function Conversations({ conversations }) {
  const urlParams = new URLSearchParams(window.location.search);
  const urlConversationId = urlParams.get("conversationId");

  const [searchQuery, setSearchQuery] = useState("");
  const fuse = new Fuse(conversations, {
    keys: [
      "contact.whatsappName",
      "contact.shopify.firstName",
      "contact.shopify.lastName",
      "lastMessagePreview",
    ],
    threshold: 0.3, // Adjust this value to control fuzziness (0.0 = exact match, 1.0 = match anything)
  });

  const [selectedConversation, setSelectedConversation] = useState(
    urlConversationId
      ? (conversations.find((c) => c.id === urlConversationId) ??
          conversations[0])
      : conversations[0] || {},
  );
  const getNextConversation = () => {
    setSelectedConversation(
      conversations[
        (conversations.map((c) => c.id).indexOf(selectedConversation.id) + 1) %
          conversations.length
      ],
    );
    api.conversation.update(
      conversations[
        (conversations.map((c) => c.id).indexOf(selectedConversation.id) + 1) %
          conversations.length
      ].id,
      {
        conversation: {
          lastReadAt: new Date(),
        },
      },
    );
  };

  useEffect(() => {
    if (conversations && conversations[0]) {
      const conversation = urlConversationId
        ? (conversations.find((c) => c.id === urlConversationId) ??
          conversations[0])
        : conversations[0];
      api.conversation.update(conversation.id, {
        conversation: {
          lastReadAt: new Date(),
        },
      });
    }
  }, []);

  const filteredConversations = searchQuery
    ? fuse.search(searchQuery).map((result) => result.item)
    : conversations;

  const [showSidebar, setShowSidebar] = useState(true);
  const [showContactDetails, setShowContactDetails] = useState(false);
  const isMobile = useIsMobile();

  useEffect(() => {
    if (isMobile && !showSidebar) {
      window.history.pushState({ sidebar: false }, "");
    }

    const handlePopState = () => {
      if (isMobile && !showSidebar) {
        setShowSidebar(true);
        setShowContactDetails(false);
      }
    };

    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [isMobile, showSidebar]);

  return (
    <>
      <div
        className={`mx-5 max-lg:h-[calc(100vh-203px)] h-[calc(100vh-148px)] ${
          isMobile ? "overflow-hidden" : ""
        }`}
        style={{ overflow: "hidden", flex: 1 }}
      >
        <Divider />
        <MainContainer
          responsive={false}
          className={`scrollbar ${isMobile ? "overflow-hidden relative" : ""}`}
        >
          {/* Sidebar */}
          <Sidebar
            key="left"
            position="left"
            scrollable={false}
            className={`
            ${
              isMobile
                ? `absolute top-0 left-0 h-full w-full bg-white
                 transition-transform duration-300 ease-in-out cs-sidebar--mobile
                 ${showSidebar ? "translate-x-0" : "-translate-x-full"}`
                : ""
            }
          `}
          >
            <Search
              placeholder="Search..."
              value={searchQuery}
              onChange={(v) => setSearchQuery(v)}
              onClearClick={() => setSearchQuery("")}
            />
            <ConversationList>
              {filteredConversations.map((conv, index) => (
                <Conversation
                  key={index}
                  active={!isMobile && conv.id === selectedConversation?.id}
                  name={conv?.contact?.whatsappName}
                  lastSenderName={
                    conv.lastMessageAt > conv.lastInboundMessageAt
                      ? "You"
                      : conv?.contact?.whatsappName?.split(" ")[0]
                  }
                  info={conv.lastMessagePreview}
                  unreadDot={conv.lastUnscriptedMessageAt > conv.lastReadAt}
                  lastActivityTime={
                    <div style={{ width: "60px" }}>
                      {getMessageDateFormatted(conv.lastMessageAt, true)}
                    </div>
                  }
                  onClick={() => {
                    setSelectedConversation(conv);
                    setShowSidebar(false);
                    api.conversation.update(conv.id, {
                      conversation: { lastReadAt: new Date() },
                    });
                  }}
                />
              ))}
            </ConversationList>
          </Sidebar>

          {/* Conversation Chat */}
          {conversations && conversations[0] ? (
            isMobile ? (
              <div
                className={`
                absolute top-0 left-0 h-full w-full bg-white
                transition-transform duration-300 ease-in-out
                ${showSidebar ? "translate-x-full" : "translate-x-0"}
              `}
              >
                <ConversationChat
                  key="conversation-chat"
                  conversation={selectedConversation}
                  getNextConversation={getNextConversation}
                  isMobile={isMobile}
                  setShowSidebar={setShowSidebar}
                  showSidebar={showSidebar}
                  showContactDetails={showContactDetails}
                  setShowContactDetails={setShowContactDetails}
                />
              </div>
            ) : (
              <ConversationChat
                key="conversation-chat"
                conversation={selectedConversation}
                getNextConversation={getNextConversation}
                isMobile={isMobile}
              />
            )
          ) : isMobile ? (
            <div style={containerStyleMobile}>
              <div style={innerDivStyle} className="h-full">
                <p style={{ fontSize: "100px", margin: 0, zIndex: "9999" }}>
                  🎉
                </p>
                <p style={{ zIndex: "9999" }}>
                  Congratulations! You have no conversation to answer
                </p>
              </div>
            </div>
          ) : (
            <div style={containerStyle}>
              <div style={innerDivStyle}>
                <p style={{ fontSize: "100px", margin: 0 }}>🎉</p>
                <br />
                <br />
                <br />
                <p>Congratulations! You have no conversation to answer</p>
              </div>
            </div>
          )}
        </MainContainer>
      </div>
    </>
  );
}

const containerStyle = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  width: "100%",
  height: "100vh", // Full viewport height
  textAlign: "center", // Center text horizontally
};

const containerStyleMobile = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  width: "100%",
  height: "100", // Full viewport height
  textAlign: "center", // Center text horizontally
  paddingTop: "25%",
};

const innerDivStyle = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
};
